import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/common/card";

import { Topbar } from "@/components/layout/topbar";
import { Content } from "@/components/layout/content";
import { EditActionForm } from "@/pages/admin/rules/actions/components/actions-edit";
import {
  getActionById,
  getActionTypesForSelect,
} from "@/pages/admin/rules/actions/lib/queries";
import { getRulesForSelect } from "@/pages/admin/rules/lib/queries";
import { DeleteEntityDialog } from "@/components/common/delete";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function ActionEdit() {
  const params = useParams();
  const [action, setAction] = useState(null);
  const [rules, setRules] = useState([]);
  const [actiontypes, setActionTypes] = useState([]);

  const getActionRulesAndActionTypes = async () => {
    const [action, rules, actiontypes] = await Promise.all([
      getActionById(params.id),
      getRulesForSelect(),
      getActionTypesForSelect(),
    ]);
    setAction(action);
    setRules(rules);
    setActionTypes(actiontypes);
  };

  useEffect(() => {
    getActionRulesAndActionTypes();
  }, [params.id]);

  return (
    <>
      <Topbar
        title="Action"
        breadcrumb={[{ title: "Actions", href: "/rules/actions" }]}
      />

      <Content>
        <Card>
          <CardHeader>
            <CardTitle>Action</CardTitle>
            <DeleteEntityDialog
              id={action?.id}
              entityType="rules/actions"
              redirectTo="/rules/actions"
            />
          </CardHeader>
          <CardContent>
            <EditActionForm
              action={action}
              rules={rules}
              actiontypes={actiontypes}
            />
          </CardContent>
        </Card>
      </Content>
    </>
  );
}
